import Query from '../../components/Report';

export default new Query('summary');
